module.exports = __webpack_public_path__ + "media/images/basic-logos/no-image-1-2cbc54864de681ea9333b3e4c428807d.png";